import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-cyan-900" data-id="element-188">
      <div className="container mx-auto px-4" data-id="element-189">
        <div className="text-center mb-16" data-id="element-190">
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[28px]" data-id="element-191">
            ELEGÍ TU CENTRALPACK
          </h2>
          <p className="text-cyan-100 text-[16px]" data-id="element-192">
            Asegurá tu acceso antes de que termine el contador.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-193">
          {/* Standard Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-cyan-950/80 rounded-3xl p-8 shadow-2xl border border-cyan-800 flex flex-col h-full" data-id="element-194">
            <div className="mb-6" data-id="element-195">
              <h3 className="font-bold text-white mb-2 flex items-center gap-2 text-[20px]" data-id="element-196">
                🧠 MEGAPACK ABA LISTO
              </h3>
              <p className="text-cyan-300 font-bold pl-[60px]" data-id="element-197">
                6 Tomos + 4 Bonos
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-cyan-800" data-id="element-198"></div>

            <div className="mb-8" data-id="element-199">
              <p className="text-cyan-400/60 line-through text-lg mb-1" data-id="element-200">
                $49.000
              </p>
              <div className="flex items-end gap-2" data-id="element-201">
                <span className="text-5xl font-black text-white" data-id="element-202">$19.990</span>
                <span className="text-xl font-bold text-cyan-300 mb-1" data-id="element-203">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-204">
              {['6 Tomos completos (Evaluación a Documentación)', '4 Bonos estratégicos', '117+ planillas imprimibles', '91+ protocolos clínicos', 'Acceso de por vida', 'Actualizaciones gratuitas'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-205">
                  <Check className="w-5 h-5 text-cyan-300 shrink-0 mt-0.5" data-id="element-206" />
                  <span className="text-cyan-50" data-id="element-207">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53530888438078:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-208">
              <Button variant="secondary" size="lg" fullWidth withArrow data-id="element-209">
                QUIERO MI CENTRALPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Pro Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-slate-950 rounded-3xl p-8 shadow-2xl border-2 border-amber-400 flex flex-col h-full relative lg:scale-105 z-10" data-id="element-210">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-amber-400 text-slate-900 px-4 py-1.5 rounded-full font-bold text-sm flex items-center gap-1.5 whitespace-nowrap shadow-lg" data-id="element-211">
              <Star className="w-4 h-4 fill-slate-900" data-id="element-212" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-213">
              <h3 className="text-2xl font-bold text-white mb-2 flex items-center gap-2" data-id="element-214">
                🚀 MEGAPACK ABA + SISTEMA MAESTRO
              </h3>
              <p className="text-amber-400 font-bold text-[14px] pl-[30px]" data-id="element-215">
                6 Tomos + 4 Bonos + Sistema de Supervisión y Coordinación
              </p>
              <p className="text-slate-400 text-sm mt-1 pl-[20px]" data-id="element-216">
                (gestión de equipo, familia y escuela)
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-slate-800" data-id="element-217"></div>

            <div className="mb-8" data-id="element-218">
              <p className="text-slate-500 line-through text-lg mb-1" data-id="element-219">
                $69.000
              </p>
              <div className="flex items-end gap-2" data-id="element-220">
                <span className="text-5xl font-black text-white" data-id="element-221">$27.990</span>
                <span className="text-xl font-bold text-slate-400 mb-1" data-id="element-222">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-223">
              <li className="flex items-start gap-3" data-id="element-224">
                <Check className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" data-id="element-225" />
                <span className="text-white font-bold" data-id="element-226">
                  Todo lo del MegaPack ABA Listo, MÁS:
                </span>
              </li>
              {['Manual relámpago para ATs (ficha completa)', 'Sistema de auditoría y evaluación del equipo', 'Contrato de colaboración familiar (formato legal)', 'Cuaderno de enlace estructurado terapia-escuela', 'Informe trimestral consolidado para Obra Social', 'Informe anual de logros completo', 'Protocolos para conflictos interdisciplinarios', 'Sistema de autocuidado del supervisor'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-227">
                  <Check className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" data-id="element-228" />
                  <span className="text-slate-300" data-id="element-229">{feature}</span>
                </li>)}
            </ul>

            <a href="https://www.centralpack.shop/cart/53530889158974:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-230">
              <Button variant="primary" size="lg" fullWidth withArrow className="text-lg" data-id="element-231">
                QUIERO EL MEGAPACK + SISTEMA MAESTRO
              </Button>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}